import React from "react";
import { useSelector } from "react-redux";
import { Container, Loader, Spacer, ProgressBar, ProgressBarFill } from "./ColdStartLoaderStyles";
import AnimatedMessage from "../../../UI/AnimatedMessage/AnimatedMessage";

export default function ColdStartLoader() {
  const progress = useSelector((state) => state.detectedPatterns.fetchProgress);
  const chartCollection = useSelector((state) => state.detectedPatterns.chartCollectionToDetect);
  
  const totalCharts = chartCollection?.charts?.length || 0;
  const processedCharts = Math.round((progress / 100) * totalCharts);
  
  console.log("Current progress:", progress);
  return (
    <Container>
      <Loader>
        <span />
        <span />
        <span />
      </Loader>
      <Spacer />
      <h1>
        <AnimatedMessage>Detecting patterns</AnimatedMessage>
      </h1>
      <ProgressBar>
        <ProgressBarFill progress={progress} />
      </ProgressBar>
      <p style={{ color: 'white', marginTop: '10px', fontSize: '14px' }}>
        Processing chart {processedCharts} of {totalCharts}
      </p>
    </Container>
  );
}
